export default "__VITE_ASSET__CjGRBrIS__"